import { getDifferenceInSeconds } from '@office-start/date-utility';
import { getFileTypeNameFromType } from './getFileTypeNameFromType';
import { getReferralFromFileType } from './getReferralFromFileType';
export function getFileClickData(item, elementId, index, action, area) {
    var _a, _b, _c, _d, _e;
    var params = {};
    params["ImpressionId" /* ImpressionId */] = item.impressionId || '';
    params["ElementId" /* ElementId */] = elementId;
    params["DocumentId" /* DocumentId */] = item.id;
    params["Referral" /* Referral */] = getReferralFromFileType(item.fileType);
    params["Index" /* Index */] = index.toString();
    params["DocumentType" /* DocumentType */] = getFileTypeNameFromType(item.fileType);
    params["Action" /* Action */] = action;
    var timeSinceLastOpened = item.lastAccessedTime
        ? getDifferenceInSeconds(item.lastAccessedTime)
        : undefined;
    if (timeSinceLastOpened !== undefined) {
        params["InactivityDuration" /* InactivityDuration */] = timeSinceLastOpened.toString();
    }
    params["Area" /* Area */] = area;
    params["Pinned" /* Pinned */] = ((_a = item.isPinned) === null || _a === void 0 ? void 0 : _a.toString()) || '';
    params["ItemIsNew" /* ItemIsNew */] = ((_b = item.isNew) === null || _b === void 0 ? void 0 : _b.toString()) || '';
    params["ItemIsShared" /* ItemIsShared */] = ((_c = item.isShared) === null || _c === void 0 ? void 0 : _c.toString()) || '';
    params["IsEmailAttachment" /* IsEmailAttachment */] =
        ((_d = item.isEmailAttachment) === null || _d === void 0 ? void 0 : _d.toString()) || '';
    params["IsOnPremOrVanity" /* IsOnPremOrVanity */] =
        ((_e = item.isOnPremOrVanity) === null || _e === void 0 ? void 0 : _e.toString()) || '';
    return params;
}
//# sourceMappingURL=getFileClickData.js.map